import React from "react";
import {
  AntDesign,
  Ionicons,
  MaterialIcons,
  Entypo,
  Feather,
  FontAwesome5,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

interface Props {
  size?: number;
  color?: string;
}

const GearIcon = ({ size = 24, color = "#000" }: Props): any => (
  <AntDesign name="setting" size={size} color={color} />
);
const PersonIcon = ({ size = 24, color = "#000" }: Props): any => (
  <Ionicons name="md-person-outline" size={size} color={color} />
);
const LogoutIcon = ({ size = 24, color = "#000" }: Props): any => (
  <MaterialIcons name="logout" size={size} color={color} />
);
const DotsIcon = ({ size = 24, color = "#000" }: Props): any => (
  <Entypo name="dots-three-vertical" size={size} color={color} />
);
const SendIcon = ({ size = 24, color = "#000" }: Props): any => (
  <MaterialIcons name="send" size={size} color={color} />
);
const HomeIcon = ({ size = 24, color = "#000" }: Props) => (
  <AntDesign name="home" size={size} color={color} />
);
const ClipIcon = ({ size = 24, color = "#000" }: Props) => (
  <Feather name="paperclip" size={size} color={color} />
);
const ImageIcon = ({ size = 24, color = "#000" }: Props) => (
  <AntDesign name="picture" size={size} color={color} />
);
const LeftArrowIcon = ({ color, size = 24 }: Props) => (
  <MaterialIcons name="keyboard-arrow-left" size={size} color={color} />
);
const CloseIcon = ({ color, size = 24 }: Props) => (
  <AntDesign name="closecircle" size={size} color={color} />
);
const PowerIcon = ({ color, size = 24 }: Props) => (
  <AntDesign name="poweroff" size={size} color={color} />
);
const TrashIcon = ({ color, size = 24 }: Props) => (
  <Entypo name="trash" size={size} color={color} />
);
const CrownIcon = ({ color, size = 24 }: Props) => (
  <FontAwesome5 name="crown" size={size} color={color} />
);

const WordIcon = ({ color, size = 24 }: Props) => (
  <MaterialCommunityIcons name="file-word" size={size} color={color} />
);
const ExelIcon = ({ color, size = 24 }: Props) => (
  <MaterialCommunityIcons name="file-excel" size={size} color={color} />
);
const PdfIcon = ({ color, size = 24 }: Props) => (
  <MaterialCommunityIcons name="file-pdf" size={size} color={color} />
);
const FileIcon = ({ color, size = 24 }: Props) => (
  <MaterialCommunityIcons name="file" size={size} color={color} />
);
const PowerPointIcon = ({ color, size = 24 }: Props) => (
  <MaterialCommunityIcons name="file-powerpoint" size={size} color={color} />
);
const PlusIcon = ({ color, size = 24 }: Props) =>
  <Entypo name="squared-plus" size={size} color={color} />


export {
  PlusIcon,
  CloseIcon,
  WordIcon,
  ExelIcon,
  PdfIcon,
  FileIcon,
  PowerPointIcon,
  PersonIcon,
  LogoutIcon,
  DotsIcon,
  GearIcon,
  SendIcon,
  HomeIcon,
  ClipIcon,
  ImageIcon,
  LeftArrowIcon,
  PowerIcon,
  TrashIcon,
  CrownIcon,
};
